import { Components } from '@mui/material';

export const MuiBackdrop: Components['MuiBackdrop'] = {
  styleOverrides: {
    root: {
      // A long-press over an open menu/drawer/dialog would otherwise start a
      // text selection on the page behind it (on iOS, popping a "Copy / Look Up"
      // toolbar over the map). Every Modal-based popout renders a full-viewport
      // backdrop, invisible for Popover/Menu, so it's the element under the
      // touch. `user-select` covers Android; the callout property is iOS-only.
      // The popout's own content is a sibling, so it stays selectable.
      WebkitTouchCallout: 'none',
      WebkitUserSelect: 'none',
      userSelect: 'none',
    },
  },
};
